import YouTube from "react-youtube";

import { type VideoPreviewProps } from "src/workouts/ExercisePreviewDialog";

export function VideoPreview(props: VideoPreviewProps) {
  const thumbnail = props.thumbnail;

  if (thumbnail.type === "uploaded-video") {
    return (
      <div key={thumbnail.videoUrl}>
        <video
          src={thumbnail.videoUrl}
          autoPlay
          loop
          muted
          playsInline
          controls={!thumbnail.isGif}
          className="w-full max-h-[60vh]"
        />
      </div>
    );
  }

  if (thumbnail.type === "youtube") {
    return (
      <div>
        <YouTube
          videoId={thumbnail.videoId}
          iframeClassName="w-full"
          opts={{
            playerVars: {
              autoplay: 1,
              mute: 1,
              loop: 1,
              playlist: thumbnail.videoId,
              playsinline: 1,
            },
          }}
        />
      </div>
    );
  }

  return (
    <div className="w-full aspect-video">
      <iframe
        src={`https://player.vimeo.com/video/${thumbnail.videoId}?autoplay=1&loop=1&muted=1&playsinline=1`}
        allow="autoplay; fullscreen; picture-in-picture"
        className="w-full h-full"
      />
    </div>
  );
}
